<script lang="ts" setup>
  import { computed } from 'vue';

  import { toSystemColor } from '@bv/utils/common/color/to-system-color';

  const props = withDefaults(
    defineProps<{
      color?: string;
      width?: string;
      stroke?: string;
    }>(),
    {
      color: 'base',
      width: '48px',
      stroke: '2px',
    },
  );

  const colors = computed(() => ({
    color: toSystemColor(props.color),
  }));
</script>

<template>
  <span class="loader" />
</template>

<style lang="scss" scoped>
  .loader {
    width: v-bind(width);
    height: v-bind(width);
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;
    display: block;
    margin: 0 auto;
  }
  .loader::before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: v-bind(stroke) solid v-bind('colors.color');
    animation: prixClipFix 2s linear infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes prixClipFix {
    0% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
  }
</style>
